import React, { Fragment } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Card, CardBody, CardHeader, Col, Container, Row, Label, Input, Spinner } from 'reactstrap';
import BreadCrumb from '../components/Common/BreadCrumb';

import { createDeepClone } from "../utils/index";

import CardLoader from "../components/CardLoader";
import ActionList from "../components/ActionList";

import { useDispatch, useSelector } from "react-redux";
import * as roleActions from "../actions/RoleActions";

const RoleEditScreen  = (props) => {
    const { register, clearErrors, reset, trigger, formState: { errors } } = useForm({mode: 'all'});

    const navigate = useNavigate();
    const { id } = useParams();

    const dispatch = useDispatch();

    const loading = useSelector((state) => state.role.loadingFBO);
    const fbo = useSelector((state) => state.role.fbo);
    
    const [fboState, setFBOState] = React.useState(fbo);
    const [isDirty, setIsDirty] = React.useState(false);

    const [refreshAction, setRefreshAction] = React.useState(false);

    React.useEffect(() => {
	    dispatch(roleActions.loadRole(id, navigate));
    }, [id]);

    React.useEffect(() => {
		setFBOState(fbo);
        setIsDirty(false);
        setRefreshAction(!refreshAction);

        if(fbo){
            reset(fbo.role);
        }

        clearErrors();
    }, [fbo]);

    const reloadAction = () => {
        setRefreshAction(!refreshAction);
    }

    const onRoleChange = (name, value) => {
        var copy_fboState = createDeepClone(fboState);
        if(value) {
            copy_fboState.role[name] = value;
        }
        else if(value === false) {
            copy_fboState.role[name] = false;
        }
        else {
            copy_fboState.role[name] = null;
        }
        
        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onSaveRole = async() => {
        const valid = await trigger();
        if(valid) {
            dispatch(roleActions.saveRole(fboState, navigate));
        }
    }

    const onCancelRole = () => {
        setFBOState(fbo);
        setIsDirty(false);
        clearErrors();
    }
    
    return(
        <Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title={fboState && fboState.role.id > 0 ? "Edit Role" : "Add Role"} />
                    <Row>
                        <Col lg={fboState && fboState.role.id > 0 ? 9 : 12}>
                            <CardLoader loading={loading} />
                            
                            <Card>
                                <CardHeader className="border-0 d-flex align-items-center">
                                    
                                    <h5 className="card-title mb-0 flex-grow-1">Role</h5>
                                    <div className="flex-shrink-0">
                                        <div className="d-flex flex-wrap gap-2">
                                            <button className="btn btn-primary btn-label"
                                                disabled={loading || !isDirty}
                                                onClick={onSaveRole}
                                            >
                                                <i className="ri-save-line label-icon align-bottom"></i> Save Role
                                            </button>
                                            <button className="btn btn-danger btn-label"
                                                disabled={loading || !isDirty}
                                                onClick={onCancelRole}
                                            >
                                                <i className="ri-close-line label-icon align-bottom"></i> Cancel
                                            </button>
                                        </div>
                                    </div>
                                </CardHeader>
                                <CardBody className="border border-dashed border-end-0 border-start-0">
                                    <Row className="gy-2">
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Role Name</Label>
                                            <input type="text" className="form-control" readOnly={true}
                                                value={(fboState && fboState.role.name) || ""}
                                            />
                                        </Col>
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Description</Label>
                                            <input type="text" className="form-control" readOnly={true}
                                                value={(fboState && fboState.role.description) || ""}
                                            />
                                        </Col>
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Module Name</Label>
                                            <input type="text" className="form-control" readOnly={true}
                                                value={(fboState && fboState.role.moduleName) || ""}
                                            />
                                        </Col>
                                        <Col xxl={12} md={12}>
                                            <Label className="form-label">Responsibility</Label>
                                            <input type="text" className="form-control" maxLength={512}
                                                value={(fboState && fboState.role.responsibility) || ""}
                                                onChange={e => onRoleChange("responsibility", e.target.value)}
                                            />
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>                            
                        </Col>
                        
                        {fboState && fboState.role.id > 0 &&
                        <Col lg={3}>
                            <ActionList id={fboState.role.id} name={"ROLE"} refreshAction={refreshAction} />
                        </Col>
                        }
                    </Row>
                </Container>
            </div>
        </Fragment>
    );
}

export default RoleEditScreen;